"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * lien de téléchargement.
 * ex paramètres :
 * data="params"
 * options="{ method : 'POST'}"
 *
 *  on-success="fileDownloaded()" : methode appelée à la fin du téléchargement (retour du côté serveur)
  *  on-start="startDownload()" : m"thode appelée au déclenchement du téléchargement (avant appel serveur)
 */
ngModule.directive("fileDownloadLink", function ($fileDownload, $uiBlock) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<span><a href="{{url}}" ng-click="download()" ng-transclude></a>' + '<tl-circular-loader class="xs" ng-if="downloading"></tl-circular-loader>' + ' </span>',
    scope: {
      url: "@",
      data: "=",
      options: "=",
      /**
       * appelé après le téléchargement
       */
      onSuccess: "&",
      /**
       * appelé après l'echec du téléchargement
       */
      onFailure: "&",
      /**
       * appelé avant l'appel serveur de telechagement
       */
      onStart: "&"
    },
    controller: function controller($scope, $element) {
      $scope.download = function () {
        // sur l'asynchrone on écite les clicks en serie...
        if ($scope.options && $scope.options.async && $scope.downloading) {
          return;
        }
        if (!($scope.options && $scope.options.async)) {
          $uiBlock.block();
        }
        if ($scope.onStart) {
          $scope.onStart();
        }
        $scope.downloading = true;
        $fileDownload.start($scope.url, $scope.data || {}, $scope.options || {}).then(function () {
          $scope.onSuccess && $scope.onSuccess();
        }, function () {
          $scope.onFailure && $scope.onFailure();
        }).finally(function () {
          $uiBlock.unblock();
          $scope.downloading = false;
        });
      };
    },
    link: function link($scope, $el, $attrs) {
      $el.click(function (event) {
        event.preventDefault();
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/file-download/fileDownloadLink.js
// module id = 2935
// module chunks = 13